import React from 'react';
import BordOneToneIcon from '../BordOneToneIcon/BordOneToneIcon';
import { TbordOneToneIcon } from '../BordOneToneIcon/BordOneToneIcon.types';
import { bordColorTheme } from '../../../styles/styles.constants';
import './BordTextButton.scss';

interface BordTextButtonProps {
  text: string;
  onClick: () => void;
  variantIconRight?: TbordOneToneIcon;
  variantIconLeft?: TbordOneToneIcon;
  customClassName?: string;
  strokeIconRight?: string;
  strokeIconLeft?: string;
  iconSizeRight?: number;
  iconSizeLeft?: number;
}

const BordTextButton = ({ text, onClick, variantIconRight, variantIconLeft, customClassName = '', strokeIconRight, strokeIconLeft, iconSizeRight = 10, iconSizeLeft = 10 }: BordTextButtonProps) => {
  return (
    <div className={`bordTextButton ${customClassName}`} onClick={onClick}>
      {variantIconLeft && <BordOneToneIcon variant={variantIconLeft} customWidth={`${iconSizeLeft}px`} stroke={strokeIconLeft || bordColorTheme.blue[100]} />}
      {text}
      {variantIconRight && <BordOneToneIcon variant={variantIconRight} customWidth={`${iconSizeRight}px`} stroke={strokeIconRight || bordColorTheme.blue[100]} />}
    </div>
  );
};

export default BordTextButton;
